import { createElement, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import Branding from "./Branding";
import SettingsNavbar from "./Layout/navbar";
import Messages from "./Messages";
import WebChat from "./Chat";
import SettingTags from "./Tags";
import HouseRules from "./HouseRules";
import FiveStarReview from "./FiveStarReview";
import Embed from "./Embed";
import API from "./API";
import HolidaySchedule from "./HolidaySchedule";
import SmartLocks from "./SmartLocks";
import Integrations from "./Integrations";
import TagGroups from "./TagGroups";

const DefaultValue = {
  branding: Branding,
  messages: Messages,
  chat: WebChat,
  "house-rules": HouseRules,
  "five-star": FiveStarReview,
  tags: SettingTags,
  "tag-groups": TagGroups,
  embed: Embed,
  api: API,
  integrations: Integrations,
  "holiday-schedule": HolidaySchedule,
  "smart-locks": SmartLocks,
};

const Settings = () => {
  const history = useHistory();
  const location = useLocation();

  let pathArray = history.location.pathname.split("/");
  let path = pathArray.pop().replace("#", "");
  let el = DefaultValue[path];

  useEffect(() => {
    if (path === "settings" || !DefaultValue[path]) {
      history.push("/settings/branding");
    }
  }, [history, path]);

  return (
    <section id="hms-settings-template">
      <div id="hms-page-title">
        <h1 className="uk-heading-small">Settings</h1>
      </div>
      <div id="hms-main-body">
        <div className="uk-width-1-1@s uk-grid" uk-grid>
          <SettingsNavbar />
          <div className="uk-width-expand hms-left-tabs-content">
            {/* <ul id="settings-tab-left" className="uk-switcher"> */}
            <ul id="settings-tab-left">{!!el && createElement(el, {})}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
